import { useHistory } from "react-router-dom";
import { useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfProductSubgroup } from '../../database/index';

import api from '../../services/api';

export const useFormCreateProductSubgroups = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [ProductSubgroupResponse, setProductSubgroupResponse] = useState<AxiosResponse | null>(null);
  const [ProductSubgroupEditedResponse, setProductSubgroupEditedResponse] = useState<AxiosResponse | null>(null);
  const history = useHistory();

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    DESCRICAO: Yup.string().required('* Campo obrigatório'),
    AX_GRUPO: Yup.string().required('* Campo obrigatório')
  });

  const saveProductSubgroup = async (ProductSubgroup: ModelOfProductSubgroup) => {
    setLoading(true);

    const newProductSubgroup: ModelOfProductSubgroup = {
      ...ProductSubgroup,
    }

    if (!!ProductSubgroupResponse) {
      api.put(`subgroups/${ProductSubgroupResponse.data.ID}`, newProductSubgroup)
        .then((response) => {
          formik.resetForm();
          setProductSubgroupEditedResponse(response);
          setProductSubgroupResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'O estoque foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      api.post('subgroups', newProductSubgroup)
        .then((response) => {
          if (window.location.href === '/ProductSubgroupForm') history.push('/listProductSubgroups')
          setLoading(false);
          setProductSubgroupResponse(response);
          setProductSubgroupEditedResponse(null);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Estoque cadastrado com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  }

  const formik = useFormik<ModelOfProductSubgroup>({
    initialValues: {
      DESCRICAO: '',
      AX_GRUPO: ''
    },
    onSubmit: async values => await saveProductSubgroup(values),
    validationSchema
  });

  return {
    getProductSubgroupFormController: {
      formik,
      loading,
      toast,
      ProductSubgroupResponse,
      ProductSubgroupEditedResponse
    },
    handleProductSubgroupFormController: {
      setProductSubgroupResponse
    }
  };
};
